import React, { useState } from 'react';
import { Provider } from 'react-redux';
import styled from 'styled-components'
import Footer from '../components/Footer';
import LoginForm from '../components/login/LoginForm';

const Login = ({$scope, $location, Auth, $routeParams, $ngRedux, Utility, store}) => {

	const loginPath = $routeParams.loginPath || 'login';

	const [loading, setLoading] = useState(true);
	
  return(
		<Provider store={store}>
			<LoginPage>
				<LoginHeader />
				<Logo src="images/logo/large-logo-with-text.png" />
				<LoginForm
					Auth={Auth}
					$routeParams={$routeParams}
					$location={$location}
					$scope={$scope}
					$ngRedux={$ngRedux}
					Utility={Utility}
					loginPath={loginPath}
					setLoading={setLoading}
				/>
			<Footer />
			</LoginPage>
			{loading && <LoadingPage /> }
		</Provider>
  )
}

const LoadingPage = styled.div`
	width: 100%;
	height: 100%;
	background-color: var(--primary-page);
	position: absolute;
	left: 0;
	top: 0;
	overflow: auto;
	z-index: 1000;
	.ant-form-item-label > label {
		font-weight: 600;
	}
`

const LoginPage = styled.div`
	width: 100%;
	height: 100%;
	background-color: var(--primary-page);
	position: absolute;
	left: 0;
	top: 0;
	overflow: auto;
	z-index: 100;
	.ant-form-item-label > label {
		font-weight: 600;
	}
`

const LoginHeader = styled.div`
	height: 50px;
	margin-right: 136px;
	user-select: none;
	-webkit-app-region:drag;
`

const Logo = styled.img`
	margin: auto;
	display: block;
`

export default Login;
